export enum PackageTypeEnum {
  PACKAGE = 1,
  PALLET = 2,
  HALF_PALLET = 3,
  NON_STANDARD_PALLET = 4
}



// WEBPACK FOOTER //
// ./src/app/model/package-type.enum.ts